import styled from 'styled-components';

export const Container = styled.div`
width: 70%;
padding: 20px 10px;
@media screen and (max-width: 820px) {
    width: 100%;
  }
  .header {
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        font-size: 32px;
        line-height: 44px;
        color: #1a237e;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        a {
          text-decoration: none;
          color: #344054;
        }
      }
      .add-campaign {
        a {
          color: #fff;
        }
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }
  .submit {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .submit-buttons {
      display: flex;
      gap: 10px;
      .cancel,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }
`;

export const FormWrapper = styled.div`
  @media screen and (max-width: 820px) {
    grid-template-columns: repeat(1, 1fr);
    border: none;
    padding: 5px;
    gap: 5px;
  }

  padding: 25px 10px;
  border-bottom: 1px solid #e0e2e6;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  label {
    margin-top: 20px;
    color: #344054;
    font-size: 14px;
  }
  p {
    margin-top: 5px;
    font-size: 14px;
    color: #667085;
  }
  .date {
    display: flex;
    gap: 10px;
  }
  .eye {
      position: relative;
      left: 199%;
      bottom: 60px;
      cursor: pointer;
      margin-bottom: -60px;
    }

  input[type="text"],
  input[type="password"],
  input[type="file"],
  input[type="date"],
  input[type="number"], select {
    width: 100%;
    //height: 43px;
    margin-top: 10px;
    border: solid 1px #e0e2e6;
    border-radius: 10px;
    padding: 12px 14px;
    transition: all 0.3s ease;

    &:focus {
      outline: #027f7f;
      border: 1px solid #03a9f4;
      background: transparent;
    }
  }
`;